export const routes = {
    index: '/',
    login: '/login',
    logout: '/logout',
    noAccess: '/no-access',
}